import { render, staticRenderFns } from "./threeLoginConfig.vue?vue&type=template&id=6573046a&scoped=true&"
import script from "./threeLoginConfig.vue?vue&type=script&lang=js&"
export * from "./threeLoginConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6573046a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6573046a')) {
      api.createRecord('6573046a', component.options)
    } else {
      api.reload('6573046a', component.options)
    }
    module.hot.accept("./threeLoginConfig.vue?vue&type=template&id=6573046a&scoped=true&", function () {
      api.rerender('6573046a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginconfig/threeLoginConfig.vue"
export default component.exports